import { render, staticRenderFns } from "./MemberViewerComponent.vue?vue&type=template&id=a89b4fdc&"
import script from "./MemberViewerComponent.vue?vue&type=script&lang=js&"
export * from "./MemberViewerComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports